export const identity = (a) => a;
export function defaultSerialiser(key) {
    return key;
}
export function defaultDeserialiser(key) {
    return key;
}
